module.exports = __webpack_public_path__ + "img/slovenian-global-business-network-logo.1b7afd5b.webp";